import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/state/auth';
import { useLogin } from '@/lib/query';
import { Droplet } from '@/components/layout/Icons';

export default function Login() {
  const [username, setUsername] = useState('operator');
  const [password, setPassword] = useState('demo123');
  const [error, setError] = useState<string | null>(null);
  const login = useLogin();
  const setUser = useAuth((s) => s.setUser);
  const mode = useAuth((s) => s.mode);
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await login.mutateAsync({ username, password });
      setUser(res.user, res.token);
      navigate('/');
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <div className="grid h-screen place-items-center bg-canvas">
      <form onSubmit={submit} className="card w-[360px] p-8">
        <div className="mb-6 flex flex-col items-center gap-3 text-center">
          <Droplet size={56} />
          <div>
            <div className="text-[16px] font-bold text-slate-800">循环水吊养 · 智能监控与管理系统</div>
            <div className="mt-1 text-[13px] text-slate-500">湖北省农科院循环水吊水养殖科研基地</div>
          </div>
        </div>
        <label htmlFor="login-user" className="mb-1 block text-[13px] text-slate-500">用户名</label>
        <input
          id="login-user"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="用户名"
          autoComplete="username"
          className="mb-4 w-full rounded-lg border border-hairline px-3 py-2 text-sm outline-none focus:border-brand-400"
        />
        <label htmlFor="login-pass" className="mb-1 block text-[13px] text-slate-500">密码</label>
        <input
          id="login-pass"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="密码"
          autoComplete="current-password"
          className="mb-4 w-full rounded-lg border border-hairline px-3 py-2 text-sm outline-none focus:border-brand-400"
        />
        {error ? <div className="mb-3 text-[13px] text-alarm-fg">{error}</div> : null}
        <button disabled={login.isPending} className="btn btn-primary w-full justify-center disabled:opacity-60">
          {login.isPending ? '登录中…' : '登录'}
        </button>
        {mode === 'demo' ? (
          <div className="mt-4 text-center text-[12px] text-slate-400">
            演示账号：operator / wangjianguo / engineer / auditor / admin · 密码 demo123
          </div>
        ) : null}
      </form>
    </div>
  );
}
